import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { categoryColumnsConfig } from "../config/Category";
// import { getCategoryWithFilter, updateCategoryStatus } from "../../../slices/thunks";
import { ConfirmPopup } from "../Confirmation";
import { useNavigate } from "react-router-dom"; 
export const getCategoryColumns = ({ onDeleteClick, onEditClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);
  const navigate = useNavigate(); // Initialize useNavigate

  const handleEditClick = (row) => {
    navigate("/category/add-form", { state: { id: row.id } }); // Pass the row ID to the /addform page
  };
  // console.log(conf);
  // const dispatch = useDispatch();
  // const handleEditClick = (row) => {
  //   navigate(`/category/addform`, { state: { data: row } });
  // };
  return [
    // {
    //   name: <span className="font-weight-bold fs-13">{categoryColumnsConfig.id}</span>,
    //   selector: (row) => row.id,
    //   sortable: true,
    // },
    {
      name: <span className="font-weight-bold fs-13">{categoryColumnsConfig.NAME}</span>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{categoryColumnsConfig.STATUS}</span>,
     cell: (row) => (
        <span
          className={`fw-semibold ${row.status ? "text-success" : "text-danger"}`}
        >
          {row.status ? "Active" : "Inactive"}
        </span> 
      ),
      sortable: false,
    },
    {
      name: <span className="font-weight-bold fs-13">{categoryColumnsConfig.ACTIONS}</span>,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 justify-content-center">
          {/* Edit Button */}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              handleEditClick(row); // Navigate and pass the ID to /addform
            }}
            className="fs-13 nav-link"
          >
            <i className="ri-edit-2-fill fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle"></i>
          </a>


          {/* Delete Button */}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setConfirmOpenForId(row.id);
            }}
            className="fs-13 nav-link"
          >
   <i
  className="ri-delete-bin-7-fill fs-16 p-2 bg-soft-danger rounded-circle align-middle icon-red"
></i>

          </a>

          {/* Confirm Delete Popup */}
          {confirmOpenForId === row.id && (
            <ConfirmPopup
              message={categoryColumnsConfig.messages}
              setConfirmOpen={() => setConfirmOpenForId(null)}
              onConfirm={(event) => {
                onDeleteClick(event, row.id);
                setConfirmOpenForId(null);
              }}
              style={{ left: "100px", top: "10px", backgroundColor: "lightblue" }} // Apply the negative right margin here
            />
          )}
        </div>
      ),
    },
  ];
};
